import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as Func from '../../../../helpers/functions';
import { getLocaleFullName, getKeyByValue } from '../../../../utils/commonUtils';
import action from '../../../../actions/index';
import Model from '../../../../constants/Model';
import * as HMS from "../../common/component/Index";
import i18n from "../../../../constants/initLng";
import moment from 'moment';
import * as OrderComponent from './component/CommonComponent';
import * as ANT from 'antd';
import DEFINE, { ORDER, SALE_CHANNELS, DATE_TIME_FORMAT, INSTALLMENT as INSTALLMENT_ENUM, CHANNELS } from "../../../../constants/Define";
import FontIcon, { SolidIcons } from '../../common/component/FontIcon';
import Span from '../../common/component/Span';
import { DatePickerComponent } from '../../common/component/Index'
import { find, omit } from 'lodash';
import SaleOrder from './SaleOrder';
import OrderAccessTrade from './OrderAccessTrade';
import './Order.less'
import { soioStatus, soioStatuscolor } from '../../../../utils/orders';
// import * as url from '../images/webpack_logo.png';

let permisionActions = [];
let orderOnline = ['onepay', 'vnpay', 'onepay_installment', 'qrcode']
const paymentMethods = [
    'OTHER',
    'SHOPEEPAY',
    'MOMO',
    'DOMESTIC',
    'MASTERCARD',
    'QRCODE',
    'GOOGLEPAY',
    'SAMSUNGPAY',
    'PROMOTION',
    'VINCLUB',
    'APPLEPAY',
    'ZALOPAY'
];
const removedColumns = [
    'id',
    'orderType',
    'firstname',
    'lastname',
    'couponValue',
    'promotionBankValue',
    'fxChargeFailNum',
    'languageCode',
    'quickTaskStatus',
    'totalChangeRateCode',
    'installmentFee',
    'installmentLimit',
    'customerLoginInfo',
];
class Orders extends Component {
    state = {
        titleTable: Func.getTitleTable(Model.OrdersModel.titleTable, ['detail'], removedColumns),
        modelOrder: Model.OrdersModel.titleTable,
        componentTable: {
            orderCode: {
                key: 'orderCode',
                width: 180,
                fixed: 'left',
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <HMS.FilterDropdown
                        setSelectedKeys={setSelectedKeys}
                        selectedKeys={selectedKeys}
                        confirm={confirm}
                        clearFilters={clearFilters}
                    >
                    </HMS.FilterDropdown>
                ),
                filterIcon: filtered => (
                    <ANT.Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                ),
                render: (orderCode, record) => (
                    <Fragment>
                        <ANT.Badge count={record?.fxChargeFailNum} style={{right: '-10px'}}>
                            {orderCode}
                        </ANT.Badge>
                    </Fragment>
                )
            },
            transactionId: {
                key: 'transactionId',
                width: 300,
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <HMS.FilterDropdown
                        setSelectedKeys={setSelectedKeys}
                        selectedKeys={selectedKeys}
                        confirm={confirm}
                        clearFilters={clearFilters}
                    >
                    </HMS.FilterDropdown>
                ),
                filterIcon: filtered => (
                    <ANT.Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                ),
                render: (transactionId, record) => orderOnline.includes(record.paymentType) ? record.id : transactionId
            },
            fullname: {
                key: 'fullname',
                render: (text, data) => data.fullname || getLocaleFullName(data.firstname, data.lastname),
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <HMS.FilterDropdown
                        setSelectedKeys={setSelectedKeys}
                        selectedKeys={selectedKeys}
                        confirm={confirm}
                        clearFilters={clearFilters}
                    >
                    </HMS.FilterDropdown>
                ),
                filterIcon: filtered => (
                    <ANT.Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                ),
            },
            phoneNumber: {
                key: 'phoneNumber',
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <HMS.FilterDropdown
                        setSelectedKeys={setSelectedKeys}
                        selectedKeys={selectedKeys}
                        confirm={confirm}
                        clearFilters={clearFilters}
                    >
                    </HMS.FilterDropdown>
                ),
                filterIcon: filtered => (
                    <ANT.Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                ),
            },
            email: {
                key: 'email',
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <HMS.FilterDropdown
                        setSelectedKeys={setSelectedKeys}
                        selectedKeys={selectedKeys}
                        confirm={confirm}
                        clearFilters={clearFilters}
                    >
                    </HMS.FilterDropdown>
                ),
                filterIcon: filtered => (
                    <ANT.Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                ),
            },
            customerLoginInfo: {
                width: 240,
                render: this.renderCustomerLoginInfo,
            },
            memberShipCode: {
                key: 'memberShipCode',
                width: 150
            },
            subTotal: {
                sorter: (i, k) => i.subTotal.length - k.length,
                align: "right",
                render: (subTotal) => Func.formatMoney(subTotal)
            },
            totalSurcharge: {
                // sorter: (i, k) => (i.surcharge || '').length - k.length,
                align: "right",
                render: (surcharge) => Func.formatMoney(surcharge)
            },
            totalChangeRateCode: {
                align: "right",
                width: 200,
                render: (totalChangeRateCode) => Func.formatMoney(totalChangeRateCode)
            },
            couponCode: {
                key: 'couponCode',
                align: "right",
                render: (couponCode, order) => {
                    return couponCode && `${couponCode || ''} (-${Func.formatMoney(order.couponValue)} ${this.props.t(`currencySymbol`)})`
                },
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <HMS.FilterDropdown
                        setSelectedKeys={setSelectedKeys}
                        selectedKeys={selectedKeys}
                        confirm={confirm}
                        clearFilters={clearFilters}
                    >
                    </HMS.FilterDropdown>
                ),
                filterIcon: filtered => (
                    <ANT.Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                ),
            },
            promotionBankCode: {
                key: 'promotionBankCode',
                title: i18n.t('item.order.paymentPromotion'),
                align: "right",
                width: 200,
                render: (promotionBankCode, order) => {
                    return promotionBankCode && `${promotionBankCode} (-${Func.formatMoney(Math.abs(Number(order.promotionBankValue) || 0))} ${this.props.t(`currencySymbol`)})`
                },
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <HMS.FilterDropdown
                        setSelectedKeys={setSelectedKeys}
                        selectedKeys={selectedKeys}
                        confirm={confirm}
                        clearFilters={clearFilters}
                    >
                    </HMS.FilterDropdown>
                ),
                filterIcon: filtered => (
                    <ANT.Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                ),
            },
            totalAmount: {
                // sorter: (i, k) => (i.surcharge || '').length - k.length,
                align: "right",
                render: (amount) => Func.formatMoney(amount)
            },
            createdDate: {
                sorter: (i, k) => i.createdDate.length - k.length,
                render: (createdDate) => moment(moment.utc(createdDate).toDate().toJSON()).format('DD-MM-YYYY HH:mm'),
            },
            status: {
                key: 'status',
                render: (status, data) => <Fragment>
                    <HMS.StatusComponent color={ ORDER['COLOR_ORDER_STATUS'][status] || 'red' }
                        label={this.props.t(`item.order.orderStatus.${status}`)} />
                   
                </Fragment>,
                filters: [
                    { value: 1, text: this.props.t(`item.order.orderStatus.1`) },
                    { value: 2, text: this.props.t(`item.order.orderStatus.2`) },
                    // { value: 3, text: this.props.t(`item.order.orderStatus.3`) },
                    // { value: 4, text: this.props.t(`item.order.orderStatus.4`) },
                    { value: 5, text: this.props.t(`item.order.orderStatus.5`) },
                    { value: 6, text: this.props.t(`item.order.orderStatus.6`) },
                    { value: 7, text: this.props.t(`item.order.orderStatus.7`) },
                    { value: 8, text: this.props.t(`item.order.orderStatus.8`) },
                    { value: 9, text: this.props.t(`item.order.orderStatus.9`) },
                ],
                filterMultiple: false,
            },
            accountantStatus: {
                key: 'accountantStatus',
                render: (accountantStatus, data) => <Fragment>
                    <HMS.StatusComponent color={ ORDER['COLOR_ORDER_STATUS'][accountantStatus] || 'red' }
                        label={this.props.t(`item.order.orderStatus.${accountantStatus}` || '')} />
                   
                </Fragment>,
                width: 150,
                filters: [
                    { value: 1, text: this.props.t(`item.order.orderStatus.1`) },
                    { value: 2, text: this.props.t(`item.order.orderStatus.2`) },
                    // { value: 3, text: this.props.t(`item.order.orderStatus.3`) },
                    // { value: 4, text: this.props.t(`item.order.orderStatus.4`) },
                    { value: 5, text: this.props.t(`item.order.orderStatus.5`) },
                    { value: 6, text: this.props.t(`item.order.orderStatus.6`) },
                    { value: 7, text: this.props.t(`item.order.orderStatus.7`) },
                    { value: 8, text: this.props.t(`item.order.orderStatus.8`) },
                    { value: 9, text: this.props.t(`item.order.orderStatus.9`) },
                ],
                filterMultiple: false,
            },
            quickTaskStatus: {
                key: 'quickTaskStatus',
                width: 90,
                align: "center",
                render: (status, data) => {
                    if(status !== 0) {
                        return <HMS.StatusComponent color={ ORDER['COLOR_ORDER_QUICK_TASK_STATUS'][status] || '' }
                        label={this.props.t(`item.order.orderQuickTaskStatus.${status}`)} />
                    }else {
                        return "-";
                    }
                }
            },
            paymentStatus: {
                key: 'paymentStatus',
                render: (paymentStatus, data) => <Fragment>
                    <HMS.StatusComponent color={paymentStatus === 2 ? 'green' : (paymentStatus === 4 ? 'blue' : 'red')}
                        label={i18n.t(`item.order.paymentStatusEnum.${paymentStatus}`)} />
                </Fragment>,
                filters: [
                    { value: 1, text: this.props.t(`item.order.paymentStatusEnum.1`) },
                    { value: 2, text: this.props.t(`item.order.paymentStatusEnum.2`) },
                    { value: 4, text: this.props.t(`item.order.paymentStatusEnum.4`) },
                ],
                filterMultiple: false,
            },
            soStatus: {
                key: 'soStatus',
                render: (soStatus, data) => {
                    return (
                        <Fragment>
                            <HMS.StatusComponent color={soioStatuscolor(soStatus)}
                            label={i18n.t(`item.order.soioStatuss.${soStatus ? soStatus : 'unhandle'}`)} />
                        </Fragment>
                        )
                    },
                filters: [
                    { value: soioStatus.SUCCESS, text: this.props.t(`item.order.soioStatuss.success`) },
                    { value: soioStatus.PUSHED, text: this.props.t(`item.order.soioStatuss.pushed`) },
                    { value: soioStatus.UNHANDLE, text: this.props.t(`item.order.soioStatuss.unhandle`) },
                ],
                filterMultiple: false,
            },
            oiStatus: {
                key: 'oiStatus',
                render: (oiStatus, data) => {
                    return (
                        <Fragment>
                            <HMS.StatusComponent color={soioStatuscolor(oiStatus)}
                            label={i18n.t(`item.order.soioStatuss.${oiStatus ? oiStatus : 'unhandle'}`)} />
                        </Fragment>
                        )
                    },
                filters: [
                    { value: soioStatus.SUCCESS, text: this.props.t(`item.order.soioStatuss.success`) },
                    { value: soioStatus.PUSHED, text: this.props.t(`item.order.soioStatuss.pushed`) },
                    { value: soioStatus.UNHANDLE, text: this.props.t(`item.order.soioStatuss.unhandle`) },
                ],
                filterMultiple: false,
            },
            paymentType: {
                key: 'paymentType',
                render: (paymentType, data) => <Fragment>
                    {paymentType && <div className="g-mt-5">
                            <HMS.StatusComponent color={'gray'}
                                label={i18n.t(`item.order.paymentTypes.${data.paymentType}`)} />
                    </div>
                    }
                </Fragment>,
                filters: [
                    { value: 'vnpay', text: this.props.t(`item.order.paymentTypes.vnpay`) },
                    { value: 'onepay', text: this.props.t(`item.order.paymentTypes.onepay`) },
                    // { value: 'zalo', text: this.props.t(`item.order.paymentTypes.zalo`) },
                    // { value: 'shopeepay', text: this.props.t(`item.order.paymentTypes.shopeepay`) },
                    { value: 'paylater', text: this.props.t(`item.order.paymentTypes.paylater`) },
                    { value: 'cash', text: this.props.t(`item.order.paymentTypes.cash`) },
                    { value: 'transfer', text: this.props.t(`item.order.paymentTypes.transfer`) },
                    { value: 'qrcode', text: this.props.t(`item.order.paymentTypes.qrcode`) },
                    { value: 'onepay_installment', text: this.props.t(`item.order.paymentTypes.onepay_installment`) },
                    { value: 'pay_at_hotel', text: this.props.t(`item.order.paymentTypes.pay_at_hotel`) },
                    { value: 'other', text: this.props.t(`item.order.paymentTypes.other`) },
                    { value: 'CreditPoint', text: this.props.t(`item.order.paymentTypes.CreditPoint`) },
                    { value: 'momo', text: this.props.t(`item.order.paymentTypes.momo`) },
                    { value: 'twoc2p', text: this.props.t(`item.order.paymentTypes.twoc2p`) },
                    { value: 'napas', text: this.props.t(`item.order.paymentTypes.napas`) },
                    { value: 'Agent Voucher', text: this.props.t(`item.order.paymentTypes.Agent Voucher`) },
                ],
                filterMultiple: false,
            },
            paymentMethod: {
                key: 'paymentMethod',
                width: 140,
                render: (paymentMethod) => paymentMethod,
                filters: paymentMethods.map(item => ({ value: item, text: item })),
                filterMultiple: false,
            },
            saleChannel: {
                key: 'saleChannel',
                render: (value, data) => value && i18n.t(`item.order.saleChannels.${value}`),
                filters: Object.keys(SALE_CHANNELS).map(item => ({ value: SALE_CHANNELS[item], text: this.props.t(`item.order.saleChannels.${SALE_CHANNELS[item]}`) })),
                filterMultiple: false,
            },
            affSource: {
                key: 'affSource',
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <HMS.FilterDropdown
                        setSelectedKeys={setSelectedKeys}
                        selectedKeys={selectedKeys}
                        confirm={confirm}
                        clearFilters={clearFilters}
                    >
                    </HMS.FilterDropdown>
                ),
                filterIcon: filtered => (
                    <ANT.Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                ),
            },
            affStatus: {
                key: 'affStatus',
                render: (affStatus, data) => affStatus.status &&
                    <Fragment>
                        <OrderComponent.RepushAffiliate
                            label={this.props.t(`item.order.affStatusItem.${affStatus.status}`)}
                            orderId={affStatus.orderId}
                            paymentStatus={affStatus.paymentStatus}
                            onRepushAffiliate={this.props.onRepushAffiliate}
                            repushAff={this.state.repushAff}
                            isAffiliateRepushed={this.state.isAffiliateRepushed}
                            idBooking={this.state.idBooking}
                        />
                    </Fragment>,

                filters: [
                    { value: 2, text: this.props.t(`item.order.affStatusItem.2`) },
                    { value: 1, text: this.props.t(`item.order.affStatusItem.1`) },
                    { value: 4, text: this.props.t(`item.order.affStatusItem.4`) },
                ],
                filterMultiple: false,
            },
            channel: {
                key: 'channels',
                render: (value, data) => value && i18n.t(`item.order.channels.${value}`),
                filters: Object.keys(CHANNELS).map(item => (
                    { value: CHANNELS[item], text: this.props.t(`item.order.channels.${CHANNELS[item]}`) 
                })),
                filterMultiple: true,
            },
            itemTypes: {
                key: 'itemTypes',
                width: 100,
                render: (types) => (
                    <Fragment>
                        {(types || []).map(type => {
                            const typeKey = find(Object.keys(ORDER.ITEMTYPES), k => ORDER.ITEMTYPES[k].id === type)
                            return typeKey &&
                                <ANT.Tooltip key={typeKey} title={this.props.t(`item.order.orderTypes.${ORDER.ITEMTYPES[typeKey].key}`)}>
                                    <Span className="ml-2">
                                        <FontIcon key={type} color={ORDER.ITEMTYPES[typeKey].color} icon={SolidIcons[ORDER.ITEMTYPES[typeKey].icon]} size="lg" />
                                    </Span> 
                                </ANT.Tooltip>
                        })}
                    </Fragment>
                ),
                filters: Object.keys(ORDER.ITEMTYPES).map(k => ({ value: ORDER.ITEMTYPES[k].id, text: this.props.t(`item.order.orderTypes.${ORDER.ITEMTYPES[k].key}`) })),
                filterMultiple: true,
            },
            installmentFee: {
                key: 'installmentFee',
                render: (value, data) => value && this.props.t(`item.group.installmentFee_enum.${value}`),
                filters: Object.keys(INSTALLMENT_ENUM.INSTALLMENT_FREE).map(item => ({ value: INSTALLMENT_ENUM.INSTALLMENT_FREE[item], text: this.props.t(`item.group.installmentFee_enum.${INSTALLMENT_ENUM.INSTALLMENT_FREE[item]}`) })),
                filterMultiple: false,
            },
            creditPoint: {
                width: 200,
                align: "center",
                render: (point) => <Fragment>{point}</Fragment>
            },
            installmentLimit: {
                key: 'installmentLimit',
                render: (value, data) => value && (
                    this.props.t(`item.group.installmentLimit_enum.${getKeyByValue(INSTALLMENT_ENUM.INSTALLMENT_LIMIT, value)}`)
                ),
                filters: [
                    { value: '6', text: this.props.t(`item.group.installmentLimit_enum.SIX_MONTH`) },
                    { value: '12', text: this.props.t(`item.group.installmentLimit_enum.TWELVE_MONTH`) },
                    { value: '6.12', text: this.props.t(`item.group.installmentLimit_enum.SIX_TWELVE_MONTH`) },
                ],
                filterMultiple: false,
            },
            detail: {
                align: "left",
                fixed: 'right',
                render: (text, record) => <OrderComponent.EditComponent item={record}
                    permisionActions={permisionActions}
                    onResendOrderEmail={this.props.onReSendOrderEmail}
                    onExportSaleOrderVoucher={this.props.onExportSaleOrderVoucher}
                    reSendMail={this.state.reSendMail}
                    idBooking={this.state.idBooking} />,
            },
        },
        orders: [],
        pageSize: this.props.orders.data.pageSize,
        pageIndex: this.props.orders.data.pageIndex,
        totalCount: this.props.orders.data.totalCount,
        totalPage: this.props.orders.data.totalPage,
        filters: this.props.orders.data.filters,
        isFetching: false,
        saleOrderOpening: false,
        orderATOpening: false,
    };

    componentDidMount() {
        permisionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.ORDER);
        const filters = this.props.orders.data.filters || {
            pageSize: this.props.orders.data.pageSize,
            pageIndex: this.props.orders.data.pageIndex,
            totalCount: this.props.orders.data.totalCount,
            totalPage: Math.ceil(parseInt(this.props.orders.data.totalCount) / parseInt(this.props.orders.data.pageSize)),
        }
        this.setState({
            ...filters,
            filters: this.props.orders.data.filters,
        })
        this.props.onListOrder(filters);
        
        const that = this
        setTimeout(() => {
          that.setState(that.state)
        }, 1500)
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            isFetching: nextProps.orders.isFetching,
            reSendMail: nextProps.orders.reSendMail,
            repushAff: nextProps.orders.repushAff,
            isAffiliateRepushed: nextProps.orders.isAffiliateRepushed,
            // repushSuccess: nextProps.orders.repushSuccess,
            idBooking: nextProps.orders.idBooking ? nextProps.orders.idBooking : 0,
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.orders.data !== prevProps.orders.data) {
            this.setState({
                orders: this.props.orders.data.result,
                pageSize: this.props.orders.data.pageSize,
                pageIndex: this.props.orders.data.pageIndex,
                totalCount: this.props.orders.data.totalCount,
                totalPage: Math.ceil(parseInt(this.props.orders.data.totalCount) / parseInt(this.props.orders.data.pageSize))
            })
        }
    }

    onSelectDateRange = (data) => {
        const filters = this.state.filters || {};
        const serialNumber = this.state.serialNumber;
        filters.pageIndex = 1;
        filters.startDate = data.fullValue[0];
        filters.endDate = data.fullValue[1];
        this.setState({
            filters
        })
        return this.props.onListOrder({...filters, serialNumber});
    }

    onChangeVoucher = (e) => {
        this.setState({serialNumber: e.target.value})
    }

    onKeyDownVoucher = event => {
        const serialNumber = this.state.serialNumber;
        if (event.keyCode === 13) {
            const filters = this.state.filters || {};
            this.props.onListOrder({...filters, serialNumber})
        }
    }

    onClickDownloadExcel = (isExcludeUserInfo = false) => {
        const filters = this.state.filters || {};
        const serialNumber = this.state.serialNumber;
        if(serialNumber) {
            this.props.exportExcel({...filters, serialNumber});
        }else {
            filters.pageIndex = filters.pageIndex || this.state.pageIndex;
            filters.pageSize = filters.pageSize || this.state.pageSize;
            filters.isExcludeUserInfo = isExcludeUserInfo;
            this.props.exportExcel(filters);
        }
    }

    onClickExportSaleOrder = () => {
        this.setState({ saleOrderOpening: true });
    }

    onClickExportAccessTrade = () => {
        this.setState({ orderATOpening: true });
    }

    onChange = (pagination, filters, sorter) => {
        let newFilters = Func.genaratePaginateFilterSort(pagination, filters, sorter);
        newFilters.startDate = this.state.filters ? this.state.filters.startDate : null;
        newFilters.endDate = this.state.filters ? this.state.filters.endDate : null;
        this.setState({
            filters: newFilters
        });        
        if(newFilters.itemTypes === 11) {
            newFilters.channels=12
        }
        this.props.onListOrder(newFilters);
    };

    getCurrentFilter = () => {

    }

    render() {
        const { t } = this.props;
        const orderState = this.props.orders;
        const {
            titleTable, orders, modelOrder,
            isFetching, totalCount, componentTable,
            totalPage, pageIndex, saleOrderOpening, pageSize,
            orderATOpening, filters, serialNumber
        } = this.state;

        return (
            <Fragment>
                <HMS.PageListComponent>
                    <HMS.HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'orders'}
                        titleHeader={t('navigation.orders')}
                        componentRight={
                            <Fragment>
                                {/* <DatePickerComponent className={`form-control applyDates w100-percent`}
                                    hmsComponent={`RangePicker`} format={DATE_TIME_FORMAT.SHORT_DATE}
                                    style={{ padding: 0, border: 0 }}
                                    onChange={this.onSelectDateRange} name={`applyDates`}
                                    placeholder={[t('placeHolderForm.startDate'), t('placeHolderForm.endDate')]}
                                    value={filters ? [filters.startDate, filters.endDate] : null}
                                /> */}
                                <ANT.Button className='btn btn-primary ml-3' title={t(`item.order.exportAccessTrade`)}
                                    disabled={orderState.isFetchingDownload}
                                    onClick={this.onClickExportAccessTrade}>
                                    <ANT.Icon type={'export'} className="mr-1" />{t(`item.order.exportAT`)}
                                </ANT.Button>
                                {permisionActions && permisionActions.allowSaleOrder &&
                                    <ANT.Button className='btn btn-primary ml-3'
                                        onClick={this.onClickExportSaleOrder}>
                                        <ANT.Icon type={'export'} className="mr-1" />{t(`item.order.exportSaleOrder`)}
                                    </ANT.Button>
                                }
                                { permisionActions && permisionActions.allowExportFileExcel &&
                                <ANT.Button className='btn btn-primary ml-3' disabled={orderState.isFetchingDownload}
                                    onClick={() => this.onClickDownloadExcel(false)}>
                                    <ANT.Icon type={orderState.isFetchingDownload ? 'loading' : 'download'} className="mr-1" />{t(`item.voucher.exportFileExcel`)}
                                </ANT.Button>
                                }
                                { permisionActions && permisionActions.allowExportExcludeUserInfo &&
                                <ANT.Button className='btn btn-primary ml-3' disabled={orderState.isFetchingDownload}
                                    onClick={() => this.onClickDownloadExcel(true)}>
                                    <ANT.Icon type={orderState.isFetchingDownload ? 'loading' : 'download'} className="mr-1" />{t(`item.report.exportExcelExcludeUser`)}
                                </ANT.Button>
                                }
                            </Fragment>
                        }
                    />
                    <div className="row filter-range-date">
                        <div className="col-md-3">
                            <HMS.FormWrapperInputComponent className="w100-percent form-contro">
                                <ANT.Input placeholder={t('item.order.searchVoucher')} type={`text`}
                                    name={`searchVoucher`}
                                    onBlur={() => this.props.onListOrder({...filters, serialNumber})}
                                    onChange={this.onChangeVoucher}
                                    onKeyDown={this.onKeyDownVoucher}
                                />
                            </HMS.FormWrapperInputComponent>
                        </div>
                        <div className="col-md-4">
                            <DatePickerComponent className={`form-control applyDates w100-percent`}
                                hmsComponent={`RangePicker`} format={DATE_TIME_FORMAT.SHORT_DATE}
                                style={{ padding: 0, border: 0 }}
                                onChange={this.onSelectDateRange} name={`applyDates`}
                                placeholder={[t('placeHolderForm.startDate'), t('placeHolderForm.endDate')]}
                                value={filters ? [filters.startDate, filters.endDate] : null}
                            />
                        </div>
                    </div>
                    <HMS.ListComponent
                        tableKey="order-list"
                        scroll={{ x: 4700 }}
                        rowKey={record => record.id}
                        loading={{ spinning: isFetching, size: 'large' }}
                        dataSource={Func.getDataSource(orders, modelOrder)}
                        columns={Func.columnsTable({
                            titleTable: titleTable,
                            component: componentTable,
                            itemName: 'order'
                        })}
                        classChildren="p-0" classParent="m-0"
                        onChange={this.onChange}
                        pagination={{ total: totalCount, totalPage: totalPage, pageSize, current: pageIndex }}
                        componentTableList={{}}
                    />
                    <SaleOrder visible={saleOrderOpening}
                        onSubmit={() => this.setState({ saleOrderOpening: false })}
                        listFilters={this.state.filters || {}}
                        onCancel={() => this.setState({ saleOrderOpening: false })} />
                    <OrderAccessTrade visible={orderATOpening}
                        onSubmit={() => this.setState({ orderATOpening: false })}
                        onCancel={() => this.setState({ orderATOpening: false })} />
                </HMS.PageListComponent>
            </Fragment>
        );
    }

    renderCustomerLoginInfo(customerLoginInfo) {
        if (!customerLoginInfo) return null;
        if (typeof customerLoginInfo !== 'object') return customerLoginInfo;

        const fullName = customerLoginInfo.fullName || customerLoginInfo.fullname ||
            getLocaleFullName(customerLoginInfo.firstName || customerLoginInfo.firstname, customerLoginInfo.lastName || customerLoginInfo.lastname);
        const phoneNumber = customerLoginInfo.phoneNumber || customerLoginInfo.phone;
        const email = customerLoginInfo.email;
        const memberShipCode = customerLoginInfo.memberShipCode || customerLoginInfo.membershipCode;
        const infoItems = [fullName, phoneNumber, email, memberShipCode].filter(Boolean);

        if (!infoItems.length) return JSON.stringify(customerLoginInfo);

        return (
            <Fragment>
                {infoItems.map((item, index) => <div key={index}>{item}</div>)}
            </Fragment>
        );
    }

}

const mapStateToProps = state => {
    return {
        orders: state.orderReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        onListOrder: (filters) => {
            dispatch(action.dataOrderAction(filters))
        },
        onReSendOrderEmail: (params) => {
            dispatch(action.reSendEmailOrderAction(params))
        },
        onRepushAffiliate: (orderId, status) => {
            dispatch(action.repushAffiliateAction(orderId, status))
        },
        onExportSaleOrderVoucher: orderId => dispatch(action.exportSaleOrderVoucherAction(orderId)),
        exportExcel: params => dispatch(action.exportExcelOrder(params))
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Orders));
